import React, { useEffect, useState } from "react";
import client from "../../lib/api";
import { formatDate } from "../../lib/api";

export default function TipsAdmin() {
  const [items, setItems] = useState(null);
  useEffect(() => { client.get("/admin/news-tips").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="tips-admin">
      <h1 className="font-head font-bold text-3xl uc mb-1">News Tips</h1>
      <p className="text-gray-500 mb-6">Reader submissions — verify before using in a story</p>
      {!items ? <p>Loading…</p> : items.length === 0 ? (
        <div className="bg-white border border-gray-200 p-12 text-center text-gray-500">No news tips yet.</div>
      ) : (
        <div className="space-y-3">
          {items.map((t) => (
            <div key={t.id} className="bg-white border border-gray-200 p-4" data-testid={`tip-${t.id}`}>
              <div className="flex justify-between items-start">
                <div>
                  <div className="font-head font-bold">{t.name} {t.location && <span className="text-gray-400 font-normal">· {t.location}</span>}</div>
                  {t.contact && <div className="text-sm text-gray-500">{t.contact}</div>}
                </div>
                <span className="text-xs text-gray-400">{formatDate(t.created_at)}</span>
              </div>
              <p className="text-gray-700 mt-2 text-sm whitespace-pre-wrap">{t.details}</p>
              {t.media_url && <a href={t.media_url} target="_blank" rel="noreferrer" className="text-r24-red text-sm underline mt-1 inline-block">View attached media</a>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
